import { translate } from "services/general";

export const duesOrders = [
  { label: translate("تم المعالجة", "Collected"), value: "collected" },
  { label: translate("متأخرة", "Delayed"), value: "delayed" },
  { label: translate("مجدولة", "Scheduled"), value: "scheduled" },
];
export const transactionTypes = [
  { label: translate("نقدي", "Cash"), value: "cash" },
  { label: translate("شيك", "Cheque"), value: "cheque" },
  { label: translate("تحويل بنكي", "Wire Transfer"), value: "wiretransfer" },
  { label: translate("دفع إلكتروني", "Online Payment"), value: "online" },
];

export const TRANSACTION_TYPES_VALUES = {
  CASH: "cash",
  CHEQUE: "cheque",
  WIRE_TRANSFER: "wiretransfer",
  ONLINE: "online",
};

export const EXPENSE_TO = [
  { name: "عميل", en_name: "Customer", value: "customer" },
  { name: "كيان", en_name: "Entity", value: "entity" },
];
export const SANADAT_TYPES = [
  { label: "مدين", en_name: "debit", value: "debit" },
  { label: "دائن", en_name: "credit", value: "credit" },
];

export const SANADAT_TRANSACTION_TYPE = {
  RECEIPT: "receipt",
  PAYMENT: "payment",
};

export const SANADAT_BTNS = [
  {
    text: "sanadat.btns.btn0",
    type: "all",
  },
  {
    text: "sanadat.btns.btn1",
    type: "payment",
  },
  {
    text: "sanadat.btns.btn2",
    type: "receipt",
  },
  {
    text: "sanadat.btns.btn3",
    type: "settlement",
  },
];
export const REF_TYPES = [
  { en_label: "Entity", label: "كيان", value: "entity" },
  { en_label: "Customer", label: "عميل", value: "customer" },
];

export const INVOICE_SALES_TYPES = [
  { en_label: "Sales", label: "فاتورة مبيعات ", value: "sales" },
  { en_label: "Sales Refund", label: "مرتجع مبيعات", value: "s_refund" },
];
export const INVOICE_PURCHASE_TYPES = [
  { en_label: "Purchase", label: "فاتورة مشتريات", value: "purchase" },
  { en_label: "rpo", label: "طلب شراء", value: "rpo" },
  { en_label: "Purchase Refund", label: "مرتجع شراء", value: "p_refund" },
  { en_label: "Po", label: "أمر شراء", value: "po" },
];

export const FINANCIAL_TREE_TYPES = [
  { label: "تشغيلي", en_label: "Operating", value: "Operating" },
  { label: "استثماري", en_label: "Investing", value: "Investing" },
  { label: "تمويلي", en_label: "Financing", value: "Financing" },
  { label: "غير محدد", en_label: "Unspecified", value: "None" },
];
export const ERROR_DATA = { status: false };

/** Display placeholder for missing values in tables, profile cards, and field grids. */
export const EMPTY_VALUE = "--";

/** The wire format the API takes a date in (`date_format:Y-m-d`). */
export const API_DATE_FORMAT = "YYYY-MM-DD";

/** The wire format the API takes a month in (`date_format:Y-m`) — e.g. a payroll period. */
export const API_MONTH_FORMAT = "YYYY-MM";

export const IDENTAL_TYPES = [
  { label: translate("جواز السفر", "Passport"), value: "passport" },
  { label: translate("الهوية الوطنية", "National"), value: "national" },
  { label: translate("الإقامة", "Iqama"), value: "iqama" },
  { label: translate("خليجي", "GCC"), value: "gcc" },
  { label: translate("إقامة مميزة", "VIP Iqama"), value: "vip_iqama" },
  { label: translate("أخرى", "Other"), value: "other" },
];
export const EMPLOYEES_STATUS = [
  { label: translate("فعال", "Active"), value: "1" },
  { label: translate("غير فعال", "Unactive"), value: "0" },
];
export const UNITS_TYPES = {
  RENT: "rent",
  BOOKING: "booking",
  SALE: "sale",
};
// Option builders take `t` so labels resolve through i18n at render time
// (CLAUDE.md §4: static user-facing text uses `t("domain.key")`, never
// `translate(ar, en)`) instead of being frozen at module-import time.
export const getPropertyTypeOptions = (t) => [
  { label: t("rent"), value: UNITS_TYPES.RENT },
  { label: t("sale"), value: UNITS_TYPES.SALE },
  { label: t("booking"), value: UNITS_TYPES.BOOKING },
];
export const getPropertyStatsOptions = (t) => [
  { label: t("units.filters.occupancy.busy"), value: "busy" },
  { label: t("units.filters.occupancy.free"), value: "free" },
];
export const getProjectStatusOptions = (t) => [
  { label: t("project.status.completed"), value: "completed" },
  {
    label: t("project.status.under_construction"),
    value: "under_construction",
  },
  { label: t("project.status.paused"), value: "paused" },
];
export const STOCK_OPTIONS = [
  { label: translate("متوفر", "In Stock"), value: "1" },
  { label: translate("غير متوفر", "Out Of Stock"), value: "0" },
];
/**
 * Language codes used across the app. `LANGUAGE` (services/general) holds one of
 * these, so branch on `LANGUAGE === LANGUAGE_CODES.AR` rather than a bare "ar".
 */
export const LANGUAGE_CODES = {
  AR: "ar",
  EN: "en",
};

/**
 * Text directions. `DIRECTION` (services/general) holds one of these, so branch on
 * `DIRECTION === TEXT_DIRECTION.RTL` rather than a bare "rtl".
 */
export const TEXT_DIRECTION = {
  RTL: "rtl",
  LTR: "ltr",
};

export const LANGUAGES = [
  { label: translate(" العربية", "Arabic "), value: "ar" },
  { label: translate(" الانجليزية", "English "), value: "en" },
];

export const SANAD_TYPES = [
  { label: translate("سند قبض", "Receipt Voucher"), value: "receipt" },
  { label: translate("سند صرف", "Payment Voucher"), value: "payment" },
];

export const SANADAT_TYPES_VALUES = {
  RECEIPT: "receipt",
  PAYMENT: "payment",
};
export const WAREHOUSE_TYPES = [
  { name: "أصول", en_name: "Assets", value: "assets" },
  { name: "معدات", en_name: "Equipments", value: "equipments" },
  { name: "نقاط بيع", en_name: "POS", value: "pos" },
  { name: "قطع غيار", en_name: "Spare Parts", value: "spareparts" },
];
export const STATUS_TYPES = [
  { name: "مفتوح", en_name: "Open", value: "open" },
  { name: "مغلق", en_name: "Closed", value: "closed" },
  { name: "قيد الانتظار", en_name: "Pending", value: "pending" },
  { name: "قيد التنفيذ", en_name: "Ongoing", value: "ongoing" },
];
export const REQUEST_TYPES = [
  { name: "استفسار", en_name: "Enquiry", value: "enquiry" },
  { name: "شكوى", en_name: "Complaint", value: "complaint" },
  { name: "طلب", en_name: "Request", value: "request" },
];

export const PRICE_WAYS = [
  { label: translate("يوم", "day"), value: "day" },
  { label: translate("أسبوع", "week"), value: "week" },
  { label: translate("شهر", "month"), value: "month" },
  { label: translate("ربع سنوي", "quarter"), value: "quarter" },
  { label: translate("سنوي", "year"), value: "year" },
];

export const INVOICE_TYPE = {
  SALES: "sales",
  S_REFUND: "s_refund",
  PURCHASE: "purchase",
  P_REFUND: "p_refund",
  CREDIT_NOTE: "credit_note",
  DEBIT_NOTE: "debit_note",
  RPO: "rpo",
  PO: "po",
};

export const PURCHASE_INVOICE_TYPES = [
  INVOICE_TYPE.PURCHASE,
  INVOICE_TYPE.RPO,
  INVOICE_TYPE.PO,
  INVOICE_TYPE.P_REFUND,
  INVOICE_TYPE.DEBIT_NOTE,
];

export const VOUCHERS_TYPES = {
  WITHDRAW: "withdraw",
  RETURN: "return",
  SUPPLY: "supply",
  TRANSFER: "transfer",
  DESTRUCTION: "destruction",
};

export const GENDER_TYPES = [
  { label: translate("ذكر", "Male"), value: "Male" },
  { label: translate("انثي", "Female"), value: "Female" },
];

export const FINANCIAL_TREES = {
  // Level 1
  Assets: "100000",
  Liabilities: "200000",
  Equity: "300000",
  Revenue: "400000",
  Expenses: "500000",

  // Level 2 - Assets
  Cash: "110000",
  AccountsReceivable: "120000",
  Investments: "130000",
  FixedAssets: "140000",
  CurrentAssets: "150000",

  // Level 3 - Cash
  BankAccount: "111000",
  CashOnHand: "112000",
  MainSafe: "112100",
  OnlinePayments: "113000",

  // Level 3 - Receivables
  RentReceivable: "121000",
  SalesAndCustomers: "122000",
  ServicesReceivable: "123000",

  // Level 3 - Fixed Assets
  Buildings: "141000",
  Land: "142000",
  Equipment: "143000",
  Vehicles: "144000",
  FurnitureAndFixtures: "145000",
  ComputerEquipment: "146000",
  ComputerSoftware: "147000",
  OtherFixedAssets: "148000",
  AccumulatedDepreciation: "149000",

  // Level 3 - Current Assets
  Inventory: "151000",
  PrepaidExpenses: "152000",
  VATRecoverable: "153000",
  EmployeeAdvances: "154000",

  // Level 2 - Liabilities, as the 2026-08 current / non-current split numbered them
  CurrentLiabilities: "210000",
  NonCurrentLiabilities: "220000",

  // Level 3 - Current liabilities
  AccountsPayable: "211000",
  TaxesPayable: "212000",
  ShortTermLoans: "213000",

  // Level 4 - Payables
  Suppliers: "211100",
  ServicesPayable: "211200",
  LandlordsPayable: "211300",

  // Level 3 - Non-current liabilities
  LongTermLoans: "221000",

  // Level 3 - Other current liabilities
  AccruedLiabilities: "218000",
  UnearnedRevenue: "219000",

  // Level 4 - Taxes
  IncomeTaxPayable: "212100",
  VATPayable: "212200",
  CommercialRentTax: "212300",
  PropertyTax: "212400",
  SalesTax: "212500",
  PayrollTax: "212600",
  CapitalGainsTax: "212700",
  EstateTax: "212800",
  OtherLocalAndRegionalTaxes: "212900",

  // Level 2 - Equity
  Capital: "310000",
  RetainedEarnings: "320000",
  Dividends: "330000",
  Reserves: "340000",
  UnrealizedGainsAndLosses: "350000",
  AccumulatedLosses: "360000",
  OpeningBalances: "380000",

  // Level 3 - Capital
  ContributedCapital: "311000",
  CommonStock: "312000",
  PreferredStock: "313000",

  // Level 3 - Reserves
  LegalReserve: "341000",
  SpecialReserve: "342000",
  GeneralReserve: "343000",

  // Level 3 - Unrealized
  UnrealizedGains: "351000",
  UnrealizedLosses: "352000",

  // Level 2 - Revenue
  RentalRevenue: "410000",
  SalesRevenue: "420000",
  ServiceRevenue: "430000",
  OtherRevenue: "440000",
  SalesDiscounts: "450000",

  // Level 3 - Rental Revenue
  BuildingRent: "411000",
  LandRent: "412000",
  ApartmentRent: "413000",
  // 413000 has been a group head since October 2026; this account under it took its postings.
  OtherApartmentRent: "413100",

  // Level 3 - Sales Revenue
  RealEstateSales: "421000",
  GoodsSales: "422000",
  OtherGoodsSales: "422100",
  OtherSales: "423000",

  // Level 3 - Services Revenue
  CleaningService: "431000",
  IroningService: "432000",
  OtherServiceRevenue: "437000",

  // Level 3 - Other Revenue
  InterestIncome: "441000",
  CapitalGains: "442000",

  // Level 3 - Sales Discounts
  EarlyPaymentDiscountRevenue: "451000",
  CashPaymentDiscountRevenue: "452000",
  QuantityDiscountRevenue: "453000",
  LoyaltyDiscountRevenue: "454000",
  SeasonalDiscountRevenue: "455000",
  PromotionalDiscountRevenue: "456000",
  SpecialOfferDiscountRevenue: "457000",

  // Level 2 - Expenses
  OperatingExpenses: "510000",
  AdministrativeExpenses: "520000",
  TaxExpenses: "540000",
  BadDebts: "550000",
  PurchaseDiscounts: "560000",

  // Level 3 - Operating Expenses
  Salaries: "511000",
  SalariesAndWages: "511300",
  RentExpense: "512000",
  MaintenanceExpense: "513000",
  ServiceExpenses: "514000",
  CostOfSales: "515000",
  PurchaseExpenses: "516000",
  InventoryWriteDown: "517000",
  DepreciationExpense: "518000",
  Utilities: "519000",

  // Level 3 - Administrative Expenses
  AdministrativeSalaries: "521000",
  OfficeExpenses: "522000",
  OtherOfficeExpenses: "522100",
  TravelExpenses: "523000",
  TransportationAndShipping: "524000",
  CommunicationExpenses: "525000",
  InsuranceExpenses: "526000",
  TrainingAndDevelopment: "527000",
  MarketingAndAdvertising: "528000",
  ToolsAndEquipment: "529000",
  ConsultingFees: "530000",
  SoftwareAndTechnology: "531000",
  SecurityExpenses: "532000",
  CleaningAndMaintenance: "533000",
  EntertainmentExpenses: "534000",
  EmployeeDiscounts: "535000",

  // Level 3 - Tax Expenses
  IncomeTax: "541000",
  VATExpense: "542000",
  CommercialRentTaxExpense: "543000",
  PropertyTaxExpense: "544000",
  SalesTaxExpense: "545000",
  PayrollTaxExpense: "546000",
  CapitalGainsTaxExpense: "547000",
  EstateTaxExpense: "548000",
  OtherTaxesExpense: "549000",

  // Level 3 - Purchase Discounts
  EarlyPaymentDiscountExpense: "561000",
  CashPaymentDiscountExpense: "562000",
  QuantityDiscountExpense: "563000",
  LoyaltyDiscountExpense: "564000",
  SeasonalDiscountExpense: "565000",
  PromotionalDiscountExpense: "566000",
  SpecialOfferDiscountExpense: "567000",
};

// Operating salaries and administrative salaries are separate branches; a wage posts to either.
export const SALARY_EXPENSE_ACCOUNT_CODES = [
  FINANCIAL_TREES.Salaries,
  FINANCIAL_TREES.AdministrativeSalaries,
];

export const FACILITIES = {
  ELECTRICITY: "electricity",
  WATER: "water",
  GAS: "gas",
};

// booking_type → max value
export const PERIOD_LIMITS = {
  hour: 24,
  day: 31,
  week: 4,
  month: 12,
  quarter: 4,
  half: 2,
  year: 1,
};

export const DEFAULT_IMAGES = {
  UNIT: "images/default/unit.png",
  CUSTOMER: "images/default/person.png",
  PRODUCT: "images/default/product.png",
  PROJECT: "images/default/project.png",
  ADMIN: "images/default/admin.png",
};

export const OPERATIONS_TYPES = {
  CREATE: "create",
  UPDATE: "update",
};

export const CUSTOM_FIELD_TYPES = {
  BOOL: "bool",
  SELECT: "select",
  NUMBER: "number",
};

export const CUSTOMER_TYPES = {
  COMPANY: "company",
  INDIVIDUAL: "individual",
};
export const CUSTOMER_TYPES_VALUES = [
  CUSTOMER_TYPES.COMPANY,
  CUSTOMER_TYPES.INDIVIDUAL,
];

export const DUES_TYPES = {
  COLLECTED: "collected",
  DELAYED: "delayed",
  SCHEDULED: "scheduled",
};
export const DUES_OWNER_TYPES = {
  CUSTOMER: "customer",
  OWNER: "owner",
};

export const DUES_STATUS_OPTIONS = [
  { value: "collected", label: translate("تم المعالجة", "Collected") },
  { value: "delayed", label: translate("متأخرة", "Delayed") },
  { value: "scheduled", label: translate("مجدولة", "Scheduled") },
];

export const COST_CENTER_TYPES = {
  UNIT: "UNIT",
  PROJECT: "PROJECT",
  PROPERTY: "PROPERTY",
};

export const COST_CENTER_OPTIONS = [
  {
    label: translate("المشاريع", "Projects"),
    value: COST_CENTER_TYPES.PROJECT,
  },
  {
    label: translate("العقارات", "Properties"),
    value: COST_CENTER_TYPES.PROPERTY,
  },
  { label: translate("الوحدات", "Units"), value: COST_CENTER_TYPES.UNIT },
];

export const PAYABLE_TYPES = {
  SALE_CONTRACT: "sell_contract",
  RENT_CONTRACT: "rent_contract",
  BOOKING_CONTRACT: "booking_contract",
  UNIT_SERVICE_ASSIGN: "unit_service_assign",
};

// A due's `kind`, mirroring `App\Enums\CustomerDueKind`. The advance payment
// (`retainer_fee`) is the first of the rent; the security deposit is the tenant's own
// money, refunded when the lease ends.
export const DUE_KIND = {
  CHARGE: "charge",
  UTILITY_CHARGE: "utility_charge",
  SECURITY_DEPOSIT: "security_deposit",
  RETAINER_FEE: "retainer_fee",
};

// How each kind of due is tagged wherever dues are listed. A charge on a lease is its
// rent. Fixed tones, not the theme's: under a green palette a themed tag reads as collected.
export const DUE_KIND_TAG = Object.freeze({
  [DUE_KIND.CHARGE]: {
    labelKey: "dues.rent",
    className: "bg-info-bg-soft text-info",
  },
  [DUE_KIND.RETAINER_FEE]: {
    labelKey: "dues.advance_payment",
    className: "bg-slate-bg-soft text-slate",
  },
  [DUE_KIND.SECURITY_DEPOSIT]: {
    labelKey: "dues.refundable_deposit",
    className: "bg-warning-bg-soft text-warning",
  },
  [DUE_KIND.UTILITY_CHARGE]: {
    labelKey: "dues.utility_charge",
    className: "bg-accent-purple-bg-soft text-accent-purple",
  },
});

// The account and meter numbers Ejar accepts for a unit's meters, the same as
// `App\Rules\UtilityNumberFormat`: a lease's electricity and water send them from the unit.
export const UTILITY_NUMBER_FORMAT = Object.freeze({
  // The electricity company's 11 digits (12 with a leading zero), or Marafiq's 8:
  // a unit's meter does not say which serves it.
  ELECTRICITY_ACCOUNT: /^(?:[1-9]\d{10}|0\d{11}|\d{8})$/,
  DIGITS: /^\d{1,20}$/,
  METER_NUMBER: /^[A-Za-z0-9]+$/,
});

export const INVOICEABLE_TYPES = {
  CUSTOMER: "customer",
  ENTITY: "entity",
  SUPPLIER: "supplier",
  EMPLOYEE: "employee",
};

export const TAXES_TYPES_OBJECT = {
  PERCENTAGE: "percentage",
  FIXED: "fixed",
};

export const CONTRACT_STATUS_CONFIG = {
  pending: {
    className: "text-amber-700 bg-amber-100",
    dotClass: "bg-amber-500",
    labelKey: "contractList.contractStatusPending",
  },
  active: {
    className: "text-[#2FB52C] bg-[#2fb52c14]",
    dotClass: "bg-[#2FB52C]",
    labelKey: "contractList.contractStatusActive",
  },
  ended: {
    className: "text-warning bg-warning-bg-soft",
    dotClass: "bg-warning",
    labelKey: "contractList.contractStatusEnded",
  },
  cancelled: {
    className: "text-danger bg-danger-bg-soft",
    dotClass: "bg-danger",
    labelKey: "contractList.contractStatusCancelled",
  },
  archived: {
    className: "text-secondary bg-gray-100",
    dotClass: "bg-gray-500",
    labelKey: "contractList.contractStatusArchived",
  },
  draft: {
    className: "text-[#4A4A4A] bg-[#E8E8E8]",
    dotClass: "bg-[#4A4A4A]",
    labelKey: "sale_contracts.status.draft",
  },
};

export const CONTRACT_STATUS_VALUES = {
  PENDING: "pending",
  ACTIVE: "active",
  ENDED: "ended",
  DRAFT: "draft",
  CANCELLED: "cancelled",
};

export const CONTRACT_STATUS_OPTIONS = [
  { value: "pending", label: translate("قيد الانتظار", "Pending") },
  { value: "active", label: translate("ساري", "Active") },
  { value: "terminated", label: translate("منتهي", "Ended") },
  { value: "draft", label: translate("مسودة", "Draft") },
  { value: "cancelled", label: translate("ملغي", "Cancelled") },
];

export const RENT_CONTRACT_STATUS_OPTIONS = [
  { value: "pending", label: translate("قيد الانتظار", "Pending") },
  { value: "active", label: translate("ساري", "Active") },
  { value: "ended", label: translate("منتهي", "Ended") },
  { value: "draft", label: translate("مسودة", "Draft") },
];

export const SELL_CONTRACT_STATUS_OPTIONS = [
  { value: "pending", label: translate("قيد الانتظار", "Pending") },
  { value: "active", label: translate("ساري", "Active") },
  { value: "draft", label: translate("مسودة", "Draft") },
  { value: "cancelled", label: translate("ملغي", "Cancelled") },
];

export const TIME_CYCLES_VALUES = {
  HOURLY: 1,
  DAILY: 2,
  MONTHLY: 3,
  QUARTERLY: 4,
  HALF: 5,
  YEARLY: 6,
};

export const ECRS_TO_AMER_ID_TYPE = {
  NATIONAL_ID: "national",
  RESIDENT_ID: "iqama",
  GCC_ID: "gcc",
  PASSPORT: "passport",
  VIP_RESIDENT_ID: "vip_iqama",
  OTHER: "other",
};

export const LOGOUT_ALL_DEVICES_ACTION_TYPE = "LogoutAllDevices";

/**
 * Row-action types drawn in the destructive (red) tone by the shared action
 * icons — the ones that remove, end or halt something.
 */
export const DESTRUCTIVE_ACTION_TYPES = [
  "Delete",
  "Terminate",
  "StopService",
  "Cancel",
  LOGOUT_ALL_DEVICES_ACTION_TYPE,
];

/**
 * Actions that are reversible but change what a record *is* — taking it off a
 * register, holding it. Amber rather than red: nothing is lost, and the way back
 * usually sits in the same row.
 */
export const CAUTION_ACTION_TYPES = ["Archive"];
